import React from 'react';
import { MfaMethod } from 'api-paths-cas';
import { IMfaMethodSelectionOptions, MfaMethodSelection } from '../../../organisms/mfa/mfaMethodSelection';
import MfaSmsIcon from '../../../atoms/mfa-sms-icon';
import MfaTotpIcon from '../../../atoms/mfa-totp-icon';

interface Props {
  onSelectTOTP: () => void;
  onSelectSMS: () => void;
  onSkip: () => void;
  canSkip?: boolean;
}

const getOptions = (onSelectTOTP: () => void, onSelectSMS: () => void): IMfaMethodSelectionOptions[] => {
  return [
    {
      id: MfaMethod.TOTP as string,
      onClick: onSelectTOTP,
      icon: <MfaTotpIcon />,
      content: <>Use an app to authenticate (recommended)</>,
    },
    {
      id: MfaMethod.SMS as string,
      onClick: onSelectSMS,
      icon: <MfaSmsIcon />,
      content: <>Send a code to a phone number</>,
    },
  ];
};

function mfaSetup(props: Props): React.ReactElement {
  return (
    <MfaMethodSelection
      options={getOptions(props.onSelectTOTP, props.onSelectSMS)}
      onSkip={props.onSkip}
      canSkip={props.canSkip}
    />
  );
}
export default mfaSetup;
